export function removeCachedKeys(appDataValues, allowedValueKeys) {
  Object.keys(appDataValues).forEach(key => {
    if (!allowedValueKeys.includes(key)) {
      delete appDataValues[key];
    }
  });
}
